module.exports = __webpack_public_path__ + "img/ckd-icon.f16dcdf7.png";